import React, { useState, useRef, useContext, useEffect } from "react";
import ReactDOM from 'react-dom';

import { Card, Col, Row } from "react-bootstrap"
import ModalMasterKpi from "./ModalMasterKpi";
import SidePanelSelectMasterKpi from "./SidePanelSelectMasterKpi";

import { useTranslation } from "react-i18next";
import { useBoolean } from '@fluentui/react-hooks';

import ProfileVerify from "../../../../components/Templates/Site/ProfileVerify";

import { __FormulaId, __KPIAgregations, __KPIPeriods, __MessageTypes, enum__FormulaId, enum__KPIPeriods } from "../../../../common/Dictionaries";

import { addVariable, addVariableList, deleteVariable, getVariableById, saveVariableById } from "../../../../services/sKPI/variable.service";

import TemplateDoc from '../../../../templates/sKPI/Mantainers/tmp_Variables.csv'

import { Checkbox, IconButton, TooltipHost } from "@fluentui/react";
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';

import { useGetVariablesMaintainer } from "../../../../hooks/services/sKPI/useOfVariable";
import { useGetTypeOfs } from "../../../../hooks/services/sKPI/useOfTypeOf";
import { useGetMeasurementUnit } from "../../../../hooks/services/sKPI/useOfMeasurementUnit";
import { useGetObjetives } from "../../../../hooks/services/sKPI/useOfObjetive";

import { downloadCSV, getGridLocalization, isNullOrEmpty, isNullUndefinedOrEmpty, showMessage, validateZeroAchievementFactorValue } from "../../../../common/Helpers";
import { useOnPresetVariableData2 } from "../../../../hooks/component/sKPI/Maintainers/useMaintainerVariable";
import { useGetMasterKpisMaintainer } from "../../../../hooks/services/sKPI/useOfMasterKpi";
import MessageBox from "../../../../components/Common/Message/MessageBox";
import { useDispatch, useSelector } from "react-redux";
import { action_setFiltredVariableList, action_setVariableList } from "../../../../reducers/actions/KPI/actions";
import MainAppContext from "../../../../MainAppContext";
import * as XLSX from 'xlsx';
import MatrixToolbar from "../../../../components/Products/sPrivilege/Matrix/MatrixToolbar";
import { applyFilters, executeScrollMovementToFixLockRowOnEditCell, handlerFilter, removeGridLocalStorageFilters, setterActionFired, useFilterActionComponentData } from "../../../../common/Helpers/JqxGridFilter";
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
export default function VariableNew(props) {
    const { _variableList: variableList } = useSelector((state) => state.variableScope);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const contextSite = useContext(MainAppContext);

    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : true;
    
    const profileHasAccess = (!contextSite.onlyObserver && inputParam_EditMode) || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)
    
    const inputParam_ShowSelection = props.inputParam_ShowSelection !== null && props.inputParam_ShowSelection !== undefined ? props.inputParam_ShowSelection : false;
    const inputParam_SetVariableSelection = props.setterSetSelectedData !== null && props.setterSetSelectedData !== undefined ? props.setterSetSelectedData : null;

    const listFormulaId = __FormulaId.filter(x => !x.disabled).map(item => { return { ...item, text: t(item.text), title: t(item.title) } });
    const listPeriods = __KPIPeriods.map(item => { return { ...item, text: t(item.text), title: t(item.title) } }).filter(x => x.key !== enum__KPIPeriods.ANY);
    const listAgregations = __KPIAgregations.map(item => { return { ...item, text: t(item.text), title: t(item.title) } });

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] = useBoolean(false);
    const [isPanelSelectMasterKpiOpen, setIsPanelSelectMasterKpiOpen] = useState(false);
    const [masterKpiSelected, setMasterKpiSelected] = useState({masterKpiId: null, firePresetData: false, masterKpiItem: null});
    const [variableIdSelected, setVariableIdSelected] = useState(null);

    const gridRef = useRef();
    const fileInputRef = useRef(null);

    const [showRequiredGlobalMessage, setShowRequiredGlobalMessage] = useState(false);
    const [editingRows, setEditingRows] = useState([]);
    const [selectAllVariables, setSelectAllVariables] = useState(false);

    const [listTypeOfs, setListTypeOfs] = useState(null);
    useGetTypeOfs(listTypeOfs, setListTypeOfs)

    const [listObjetives, setListObjetives] = useState(null);
    useGetObjetives(listObjetives, setListObjetives)

    const [listMeasurmentUnits, setListMeasurmentUnits] = useState(null);
    useGetMeasurementUnit(listMeasurmentUnits, setListMeasurmentUnits)

    const [listMasterKpis, setListMasterKpis] = useState(null);
    useGetMasterKpisMaintainer(listMasterKpis, setListMasterKpis)

    useGetVariablesMaintainer(variableList)

    useOnPresetVariableData2(gridRef?.current?.props.source.records, masterKpiSelected, setMasterKpiSelected, variableIdSelected)

    useFilterActionComponentData(gridRef, messageConfig, "Variable");

    useEffect(() => {
        if (variableList === null) {
            removeGridLocalStorageFilters("Variable")
        }

    }, [variableList]);

    const setterIsPanelSelectMasterKpiOpen = (value) => {
        setIsPanelSelectMasterKpiOpen(value)
        showMessage(setMessageConfig, false, __MessageTypes.WARNING, '');
        setterActionFired("Variable", 1);
    }

    const handlerAddNewRow = (obj) => {
        const _lowerId = variableList.length !== 0 ? variableList.reduce((min, obj) => obj.id < min ? obj.id : min, variableList[0].id) : 0;
        const lowerId = variableList.length === 0 ? -1 : (_lowerId > 0 ? ((_lowerId * -1) - 1) : _lowerId -1);

        const newRow = !obj ? {
            id                      : lowerId,
            variableCode            : "",
            name                    : "",
            description             : "",
            masterKpiId             : null,
            typeOfId                : null,
            measurementUnitId       : null,
            measurementPeriodId     : null,
            timeAggregationId       : null,
            useOfVariables          : false,
            k1                      : "",
            k2                      : "",
            v1Name                  : "",
            v2Name                  : "",
            byDefault               : false,
            objetiveId              : null,
            goal                    : "",
            zeroAchievementFactor   : "",
            transversal             : false,

            formula                 : "",
            formulaId               : null,
        } : {
            id                      : lowerId,
            variableCode            : obj.masterKpiCode,
            name                    : obj.name,
            description             : obj.description,
            masterKpiId             : obj.masterKpiId,
            typeOfId                : obj.typeOfId,
            measurementUnitId       : obj.measurementUnitId,
            measurementPeriodId     : obj.measurementPeriodId,
            timeAggregationId       : obj.timeAggregationId,
            useOfVariables          : obj.useOfVariables,
            k1                      : obj.k1,
            k2                      : obj.k2,
            v1Name                  : obj.v1Name,
            v2Name                  : obj.v2Name,
            byDefault               : obj.byDefault,
            objetiveId              : obj.objetiveId,
            goal                    : obj.goal,
            zeroAchievementFactor   : obj.zeroAchievementFactor,
            transversal             : obj.transversal,

            formula                 : "",
            formulaId               : obj.formulaId,
        };

        gridRef.current.beginupdate();
        gridRef.current.addrow(null, newRow, 'first');

        variableList.unshift(newRow);
        dispatch(action_setVariableList(variableList))

        if (editingRows.length > 0 ? editingRows.find(x => x === lowerId) === undefined : true) {
            editingRows.push(lowerId)
            setEditingRows(editingRows);
        }

        gridRef.current.endupdate();
        gridRef.current.updatebounddata('rows');
        setterActionFired("Variable", 1)
    };

    const handlerUploadData = () => {
        fileInputRef.current.click();
    };

    const handlerFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const convertedData = jsonData.slice(1).map((row, rowIndex) => {
                const convertedRow = {};
                row.forEach((cell, columnIndex) => {
                    const columnName = getColumns().find(x => x.index === columnIndex).dataField;
                    convertedRow[columnName] = cell;
                });

                convertedRow.id = null;

                return convertedRow;
            });

            convertedData.forEach(element => {
                handlerAddNewRow(element)
            });
        };

        reader.readAsArrayBuffer(file);
        fileInputRef.current.value = '';
    };

    const getValue = (column, row) => {
        const itemValue = column.editorOptions.find(x => x.key === row[column.dataField])

        return !isNullUndefinedOrEmpty(itemValue) ? itemValue.text : "";
    };

    const onChangeSelectAllVariables = (ev, checked) => {     
        variableList.forEach(variable => {
            variable.selection = checked;
        });

        const copia_listVariable = JSON.parse(JSON.stringify(variableList));
        dispatch(action_setVariableList(copia_listVariable));

        if (checked) {
            inputParam_SetVariableSelection && inputParam_SetVariableSelection(gridRef?.current?.props.source.records);
        }
        else {
            inputParam_SetVariableSelection && inputParam_SetVariableSelection(null);
        }

        setSelectAllVariables(checked);
    };

    const handlerExportData = (exportData) => {
        const workbook = XLSX.utils.book_new();

        const aux_rows = []

        if (exportData) {
            const aux_list = variableList.filter(x => x.id > 0);

            aux_list.forEach(row => {
                let aux_row = {};
                getColumns().forEach(column => {
                    if (column.exportable) {
                        if (column.columntype === 'dropdownlist') {
                            if (column.dataField !== 'masterKpiId') {
                                aux_row[column.dataField] = row[column.dataField] !== null ? getValue(column, row) : "";
                            }
                            else {
                                const masterKpi = listMasterKpis.find(x => x.id.toString() === row[column.dataField].toString())
                                aux_row[column.dataField] = masterKpi !== undefined && masterKpi !== null ? masterKpi.name : "";
                            }
                        }
                        else {
                            if (column.dataField !== 'masterKpiId') {
                                aux_row[column.dataField] = row[column.dataField];
                            }
                            else {
                                const masterKpi = listMasterKpis.find(x => x.id.toString() === row[column.dataField].toString())
                                aux_row[column.dataField] = masterKpi !== undefined && masterKpi !== null ? masterKpi.name : "";
                            }
                        }
                    }
                });
    
                aux_rows.push(aux_row);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: getColumns().filter(x => (exportData ? x.exportable : x.uploadMasive)).map(column => column.dataField) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

        if (exportData) {
            XLSX.writeFile(workbook, 'Variable_ExportedData.xlsx');
        }
        else {
            XLSX.writeFile(workbook, 'Variable_UploadTemplate.xlsx');
        }
    };

    const validateObject = (object) => {
        let isValid = object.name !== undefined && object.name !== null && object.name !== '';
        isValid = isValid ? object.formulaId !== undefined && object.formulaId !== null && object.formulaId !== '' : isValid;
        isValid = isValid ? object.goal !== undefined && object.goal !== null && object.goal !== '' : isValid;
        isValid = isValid ? object.masterKpiId !== undefined && object.masterKpiId !== null && object.masterKpiId !== '' : isValid;
        isValid = isValid ? object.measurementPeriodId !== undefined && object.measurementPeriodId !== null && object.measurementPeriodId !== '' : isValid;
        isValid = isValid ? object.measurementUnitId !== undefined && object.measurementUnitId !== null && object.measurementUnitId !== '' : isValid;
        isValid = isValid ? object.objetiveId !== undefined && object.objetiveId !== null && object.objetiveId !== '' : isValid;
        isValid = isValid ? object.typeOfId !== undefined && object.typeOfId !== null && object.typeOfId !== '' : isValid;

        if (object.useOfVariables === true || object.useOfVariables === "true") {
            isValid = isValid ? object.k1 !== undefined && object.k1 !== null && object.k1 !== '' : isValid;
            isValid = isValid ? object.k2 !== undefined && object.k2 !== null && object.k2 !== '' : isValid;

            if (object.formulaId !== enum__FormulaId.SIMPLE) {
                isValid = isValid ? object.v1Name !== undefined && object.v1Name !== null && object.v1Name !== '' : isValid;
                isValid = isValid ? object.v2Name !== undefined && object.v2Name !== null && object.v2Name !== '' : isValid;
            }
            else {
                isValid = isValid ? object.v1Name !== undefined && object.v1Name !== null && object.v1Name !== '' : isValid;
            }
        }

        return isValid;
    };

    const isValidFormControls = (list) => {
        let isValidForm = true;

        list.forEach(element => {
            isValidForm = isValidForm ? validateObject(element) : isValidForm;
        });

        return isValidForm;
    };

    const setterMasterKpiOnList = (masterKpiId, controlName, masterKpiSelected) => {
        setMasterKpiSelected({ masterKpiId: masterKpiId, firePresetData: true, masterKpiItem: masterKpiSelected });
    };

    const handlerSaveAll = async () => {
        const aux_list = [];
        
        variableList.filter(x => x.id <= 0).map((obj, index) => (  
            aux_list.push({
                id                      : obj.id,
                variableCode            : obj.variableCode === undefined ? "" : obj.variableCode,
                name                    : obj.name,
                description             : obj.description,
                masterKpiId             : obj.masterKpiId,
                typeOfId                : obj.typeOfId,
                measurementUnitId       : obj.measurementUnitId,
                measurementPeriodId     : obj.measurementPeriodId,
                timeAggregationId       : obj.timeAggregationId,
                useOfVariables          : obj.useOfVariables,
                k1                      : obj.k1,
                k2                      : obj.k2,
                v1Name                  : obj.v1Name.toString(),
                v2Name                  : obj.v2Name.toString(),
                byDefault               : obj.byDefault,
                objetiveId              : obj.objetiveId,
                goal                    : obj.goal,
                zeroAchievementFactor   : obj.zeroAchievementFactor,
                transversal             : obj.transversal,
                
                formula                 : "",
                formulaId               : obj.formulaId,

                internalCode            : obj.internalCode === undefined ? "" : obj.internalCode,obj
            })
        ));

        if (!isValidFormControls(aux_list)) {
            await addVariableList(aux_list).then((response) => {
                if (response.data.succeeded) {
                    window.location.reload();
                    /*if (itemsWithProblems.length > 0) {
                        showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-operationperformedpartially'))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }

                    if (response.data.data.length > 0) {
                        let responseDataList = response.data.data;
                        result.validItems.forEach(itemToAdd => {
                            itemToAdd.id = responseDataList.find(x => x.name === itemToAdd.name).id
                        });

                        dispatch(action_setVariableList(result.validItems))
                        dispatch(action_setFiltredVariableList(result.validItems))
                    }*/
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("Variable", 1)
            }).catch((error) => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("Variable", 1)
            });
        } else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
            setterActionFired("Variable", 1)
        }
    };

    const onGetTemplateClick = (type) => {
        const linkExport = document.getElementById("btnGetTemplateJson");
        let exportFileName = "";
        let excelStrData = "Id;Name\n";
        
        switch (type) {
            case "MKpi":
                exportFileName = t('data-lang-lbl-masterkpi') + ".csv";
                variableList.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "TPOf":
                exportFileName = t('data-lang-lbl-typeof') + ".csv";
                listTypeOfs.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "MUnit":
                exportFileName = t('data-lang-lbl-measurementunit') + ".csv";
                listMeasurmentUnits.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "Obj":
                exportFileName = t('data-lang-lbl-objetives') + ".csv";
                listObjetives.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "Frm":
                exportFileName = t('data-lang-lbl-field-formulaid') + ".csv";
                listFormulaId.forEach(element => {
                    excelStrData += element.key + ";" + t(element.text) + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "Period":
                exportFileName = t('data-lang-lbl-measurementperiod') + ".csv";
                listPeriods.forEach(element => {
                    excelStrData += element.key + ";" + t(element.text) + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "Agg":
                exportFileName = t('data-lang-lbl-timeaggregation') + ".csv";
                listAgregations.forEach(element => {
                    excelStrData += element.key + ";" + t(element.text) + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "MasterKpi":
                exportFileName = t('data-lang-lbl-masterkpi') + ".csv";
                listMasterKpis.forEach(element => {
                    excelStrData += element.id + ";" + t(element.name) + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "Data":
                const btnGetTemplate = document.getElementById('btnGetTemplate');
                btnGetTemplate.click();
                break;
            default:
                break;
        }
    };

    const handlerSave = async (itemId) => {
        const item = gridRef.current.props.source.records.find(x => parseInt(x.id) === itemId);
        const itemValidation = validateObject(item)
        const zeroAchievementFactorValue = validateZeroAchievementFactorValue(item.objetiveId, item.zeroAchievementFactor);
        
        if (itemValidation && zeroAchievementFactorValue) {
            if (item.id <= 0) {
                item.variableNemo = "";
                item.variableCode = "";
        
                item.internalCode = "";
                item.formula = "";
                item.masterKpiName = "";
                item.useOfVariables = item.useOfVariables !== null ?  (typeof item.useOfVariables === 'boolean' ? item.useOfVariables : item.useOfVariables.toLowerCase() === 'yes') : false;
                
                await addVariable(item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id))

                        variableList.forEach(element => {
                            if (element.id === parseInt(item.id)) {
                                element.id = serviceResponse.data.data.id;
                                element.variableCode = serviceResponse.data.data.variableCode;
                            }
                        });

                        dispatch(action_setVariableList(variableList))
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else if (!isNullUndefinedOrEmpty(serviceResponse.data.message)) {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(serviceResponse.data.message))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    } 
                    setterActionFired("Variable", 1)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setterActionFired("Variable", 1)
                });
            }
            else {
                await saveVariableById(itemId, item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id))
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else if (!isNullUndefinedOrEmpty(serviceResponse.data.message)) {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(serviceResponse.data.message))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }  
                    setterActionFired("Variable", 1)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setterActionFired("Variable", 1)
                });
            } 

            setShowRequiredGlobalMessage(false);
        }
        else {

            if (!zeroAchievementFactorValue) {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-zeroachievmentfactorerror'))    
            }
            else {
                showMessage(setMessageConfig, false, __MessageTypes.SUCCESS, '')    
            }

            if (!itemValidation) {
                setShowRequiredGlobalMessage(true);
            }
            else {
                setShowRequiredGlobalMessage(false);
            }
        }
    };

    const handlerDelete = async (itemId) => {
        if (itemId <= 0) {
            const newVariableList = variableList.filter(x => x.id !== itemId);
            dispatch(action_setVariableList(newVariableList))
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            setterActionFired("Variable", 1)
        }
        else {
            await deleteVariable(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    const newVariableList = variableList.filter(x => x.id !== itemId);
                    dispatch(action_setVariableList(newVariableList))
                    setEditingRows(editingRows.filter(x => x !== itemId));

                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("Variable", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("Variable", 1)
            });
        }
    };

    const handlerCancel = async (itemId) => {
        if (itemId === null) {
            const newVariableList = variableList.filter(x => x.id !== itemId);
            dispatch(action_setVariableList(newVariableList))
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            setterActionFired("Variable", 1)
        }
        else {
            await getVariableById(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {

                    variableList.forEach(element => {
                        if (serviceResponse.data.data.id === element.id) {
                            for (const property in serviceResponse.data.data) {
                                element[property] = serviceResponse.data.data[property]
                            }
                        }
                    });
            
                    dispatch(action_setVariableList(variableList))
                    setEditingRows(editingRows.filter(x => x !== itemId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("Variable", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("Variable", 1)
            });
        }
    };
   
    const onClick_OpenLateralPanel = (item) => {
        setVariableIdSelected(item.id)
        setMasterKpiSelected({masterKpiId: item.masterKpiId, firePresetData: false, masterKpiItem: null})

        setIsPanelSelectMasterKpiOpen(true);
        showMessage(setMessageConfig, false, __MessageTypes.SUCCESS, null)
        setterActionFired("Variable", 1)
    };

    const onClick_OpenModal = (item) => {
        setMasterKpiSelected({masterKpiId: item.masterKpiId, firePresetData: false, masterKpiItem: null})
        setVariableIdSelected(item.variableId)
        showModal();
        showMessage(setMessageConfig, false, null, null)
        setterActionFired("Variable", 1)
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return variableList[rowIndex.boundindex].id;
        }
        return variableList[rowIndex]?.id;
    };

    const onCellvaluechanged = (e) => {
        const currentColumn = e.owner._columns.find(x => x.datafield === e.args.datafield);

        if (currentColumn.columntype === "dropdownlist") {
            variableList[e.args.rowindex][e.args.datafield] = e.args.value.value
        }
        else {
            variableList[e.args.rowindex][e.args.datafield] = e.args.value
        }

        const copia_listVariable = JSON.parse(JSON.stringify(variableList));
        dispatch(action_setVariableList(copia_listVariable))

        if (editingRows.find(x => x === variableList[e.args.rowindex].id) === undefined) {
            editingRows.push(variableList[e.args.rowindex].id)
        }

        inputParam_SetVariableSelection && inputParam_SetVariableSelection(gridRef?.current?.props.source.records.filter(x => x.selection === true))

        setEditingRows(editingRows);
        applyFilters(gridRef, 'Variable', false);

        executeScrollMovementToFixLockRowOnEditCell(gridRef);
    };

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        const isEditing = editingRows.find(x => x === itemId);

        return  <>
                {
                    profileHasAccess &&
                    <>
                            {isEditing ? (
                                <>
                                    {
                                        itemId <= 0 ? (
                                            <>
                                                <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                                <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                            </>
                                        ) : (
                                            <>
                                                <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                                <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancelar" ariaLabel="Cancelar" onClick={() => fieldActionHandler(itemId, 'cancel')} />
                                                <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                            </>
                                        )
                                    }
                                </>
                            ) : (
                                <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                            )}
                        </>
                }
                </>
    };

    const getCellStyles = (row, column, value) => {

        let color = "transparent";
        let title = undefined;

        if (column.required && inputParam_EditMode) {
            if (isNullOrEmpty(value)) {
                title = t('data-lang-lbl-required')
                color = "#FF3A4B";
            }
            else {
                if (row._rowState !== undefined) {
                    if (row._rowState !== null) {
                        if (row._rowState === false) {
                            title = t('data-lang-lbl-required')
                            color = "#FF3A4B";
                        }
                        else {
                            title = t('data-lang-lbl-saved')
                            color = "#7fd7a7";
                        }
                    }
                    else {
                        title = t('data-lang-lbl-pendingsave')
                        color = "#000000";
                    }
                } else {
                    title = t('data-lang-lbl-doubleclickandmodify')
                    color = "transparent";
                }
            }
        }
        else {
            title = t('data-lang-msg-doubleclickandmodify')
            color = "transparent";
        }

        if (column.key === 'zeroAchievementFactor') {
            const isValidRow = validateZeroAchievementFactorValue(row.objetiveId, row.zeroAchievementFactor);

            if (isValidRow) {
                title = t('data-lang-lbl-pendingsave')
                color = "#000000";
            }
            else {
                title = t('data-lang-lbl-zeroachievementfactor-error')
                color = "#FF3A4B";
            }
        }

        return {
            style: {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: color
            },
            title: title
        }
    };

    const masterKpiCellsRenderer = (row, column, mainList, auxList) => {
        try {
            const aux_row = typeof row === 'number' && !isNaN(row) ? mainList[row] : row.bounddata
            const customStyle = getCellStyles(aux_row, column, aux_row[column]);

            const editable = inputParam_ShowSelection ? false : profileHasAccess;

            //applyFilters(gridRef, 'Variable', false);

            return  (<Row className='h-100 d-flex' style={customStyle.style}>
                        <Col style={{overflow: 'hidden'}}>
                            <TooltipHost content={aux_row[column] ? auxList.find(x => x.id === aux_row[column]).name : aux_row.masterKpiName} calloutProps={{ gapSpace: 0 }} styles={{ root: { display: 'inline-block' } }} >
                                <div className='px-2'>{aux_row[column] ? auxList.find(x => x.id === aux_row[column]).name : aux_row.masterKpiName}</div>
                            </TooltipHost>
                        </Col>
                        <Col className='d-flex col-auto ms-auto'>
                            <IconButton title={t('data-lang-btn-view')} className='pb-2' iconProps={{iconName: "View"}} onClick={() => onClick_OpenModal(aux_row)} />
                            {  
                                editable &&
                                <IconButton title={t('data-lang-btn-edit')} className='pb-2' iconProps={{iconName: "Edit"}} onClick={() => onClick_OpenLateralPanel(aux_row)} />
                            }
                        </Col>
                    </Row>)
        } catch (error) {
            //applyFilters(gridRef, 'Variable', false);
            return
        }
    };

    const fieldActionHandler = (itemId, actionType) => {
        switch (actionType) {
            case 'save':
                handlerSave(itemId)
                break;
            case 'delete':
                handlerDelete(itemId)
                break;
            case 'cancel':
                handlerCancel(itemId)
                break;
            default:
                break;
        }
    };

    const cellsRenderer = (rowIndex, cellValue, editor, cellText, width, height, auxListData, cellType, subType) => {
        switch (cellType) {
            case 'textbox':
                switch (subType) {
                    case "currency":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: false,
                            symbol: '$',
                            groupSeparator: ',',
                            decimalSeparator: '.',
                            digits: 19, 
                            max: 9999999999,
                        });
                        break;
                    case "number":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: true,
                            groupSeparator: ',',
                            decimalSeparator: '.',
                            digits: 19, 
                            max: 9999999999,
                        });
                        break;
                    default:
                        break;
                }
                break;
            case 'datetimeinput':
                break;
            case 'checkbox':
                editor.jqxCheckBox({ checked: (cellValue === 1 || cellValue === '1' || cellValue === 'True' || cellValue === 'true'), width: width });
                break;
            case 'dropdownlist':
                editor.jqxDropDownList({
                    width: width,
                    height: height,
                    source: getListColumnAdapter(auxListData, 'key', 'text'),
                    displayMember: 'text',
                    valueMember: 'key',
                    autoDropDownHeight: auxListData.length < 5
                });
                break;
            default:
                break;
        }
    };

    const cellRenderClassStyle = (row, columnfield, value, columnType) => {
        let className = "";
        if (inputParam_EditMode) {
            switch (columnType) {
                case "textbox":
                    if (value === '') {
                        className = 'jqx-custom-validation-red';
                    }
                    else {
                        className = '';
                    }
                    break;
                case "numberinput":
                    if (value < 0 || value === '') {
                        className = 'jqx-custom-validation-red';
                    }
                    else {
                        className = '';
                    }
                    break;
                case "datetimeinput":
                    if (value === '') {
                        className = 'jqx-custom-validation-red';
                    }
                    else {
                        className = '';
                    }
                    break;
                case "dropdownlist":
                    if (value === null || value === '' || value === 0) {
                        className = 'jqx-custom-validation-red';
                    }
                    else {
                        className = '';
                    }
                    break
                default:
                    break;
            }
        }

        return className;
    };

    const getListColumnAdapter = (listObjetcs, key, text) => {
        return new jqx.dataAdapter({
            datafields: [
                { name: text, type: 'string' },
                { name: key, type: 'number' }
            ],
            datatype: 'array',
            localdata: listObjetcs
        }, { autoBind: true });
    };

    const getColumns = () => {
        let basicColumns = null;

        if (!inputParam_ShowSelection) {
            basicColumns = [
                { index: null, text: 'ID',                                       dataField: 'id',                    uploadMasive: false, exportable: false, width: '0px',   columntype: 'textbox', editable: false, hidden: true },
                { index: null, text: t('data-lang-lbl-actions'),                 dataField: 'acciones',              uploadMasive: false, exportable: false, width:  '100px', pinned: true,
                    createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                    initwidget:   (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                },              
                { index: null, text: t('data-lang-lbl-code'),                    dataField: 'variableCode',          uploadMasive: false, exportable: true,  width: '120px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'),           columntype: 'textbox',        editable: false, pinned: true },
                { index: 0,    text: t('data-lang-lbl-name'),                    dataField: 'name',                  uploadMasive: true,  exportable: true,  width: '370px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'),           columntype: 'textbox',        cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: profileHasAccess, pinned: true },
                { index: 1,    text: t('data-lang-lbl-description'),             dataField: 'description',           uploadMasive: true,  exportable: true,  width: '400px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'),           columntype: 'textbox',        editable: profileHasAccess },
                { index: 2,    text: t('data-lang-lbl-masterkpi'),               dataField: 'masterKpiId',           uploadMasive: true,  exportable: true,  width: '200px',
                    createwidget: (row, column, value, htmlElement) => { ReactDOM.render(masterKpiCellsRenderer(row, 'masterKpiId', variableList, listMasterKpis), htmlElement); },
                    initwidget:   (row, column, value, htmlElement) => { ReactDOM.render(masterKpiCellsRenderer(row, 'masterKpiId', variableList, listMasterKpis), htmlElement); },
                },
                { index: 3,    text: t('data-lang-lbl-typeof'),                  dataField: 'typeOfId',              uploadMasive: true,  exportable: true,  width: '100px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listTypeOfs, 'dropdownlist'),         columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'TypeOf_Id',            editorOptions: listTypeOfs },
                { index: 4,    text: t('data-lang-lbl-measurementunit'),         dataField: 'measurementUnitId',     uploadMasive: true,  exportable: true,  width: '150px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listMeasurmentUnits, 'dropdownlist'), columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'MeasurementUnit_Id',   editorOptions: listMeasurmentUnits },  
                { index: 5,    text: t('data-lang-lbl-measurementperiod'),       dataField: 'measurementPeriodId',   uploadMasive: true,  exportable: true,  width: '150px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listPeriods, 'dropdownlist'),         columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'MeasurementPeriod_Id', editorOptions: listPeriods },
                { index: 6,    text: t('data-lang-lbl-timeaggregation'),         dataField: 'timeAggregationId',     uploadMasive: true,  exportable: true,  width: '150px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listAgregations, 'dropdownlist'),     columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'TimeAggregation_Id',   editorOptions: listAgregations },
                { index: 7,    text: t('data-lang-lbl-useOfVariables'),          dataField: 'useOfVariables',        uploadMasive: true,  exportable: true,  width: '100px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'checkbox', 'string'),          columntype: 'checkbox',       cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: profileHasAccess },

                { index: 8,    text: t('data-lang-lbl-field-k1'),                dataField: 'k1',                    uploadMasive: true,  exportable: true,  width: '100px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'number'),           columntype: 'numberinput',
                    cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),
                    editable: profileHasAccess, cellsformat: 'd3', cellsalign: 'right' },        
                { index: 9,   text: t('data-lang-lbl-field-k2'),                dataField: 'k2',                    uploadMasive: true,  exportable: true,  width: '100px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'number'),           columntype: 'numberinput',
                    cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),
                    editable: profileHasAccess, cellsformat: 'd3', cellsalign: 'right' },  

                { index: 10,   text: t('data-lang-lbl-field-v1name'),            dataField: 'v1Name',                uploadMasive: true,  exportable: true,  width: '150px',
                    createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'),
                    columntype: 'textbox',
                    cellclassname: (rowIndex, columnField, cellValue, rowData) => {
                        let className = "";

                        if (rowData["useOfVariables"] === true || rowData["useOfVariables"] === "TRUE" || rowData["useOfVariables"] === "true" || rowData["useOfVariables"] === 1 || rowData["useOfVariables"] === "1") {
                            if (cellValue === '') {
                                className = 'jqx-custom-validation-red';
                            }
                            else {
                                className = '';
                            }
                        }

                        return className;
                    },
                    editable: profileHasAccess },        
                
                { index: 11,   text: t('data-lang-lbl-field-v2name'),            dataField: 'v2Name',                uploadMasive: true,  exportable: true,  width: '150px',
                    createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'),
                    columntype: 'textbox',
                    cellclassname: (rowIndex, columnField, cellValue, rowData) => {
                        let className = "";

                        if (rowData["useOfVariables"] === true || rowData["useOfVariables"] === "TRUE" || rowData["useOfVariables"] === "true" || rowData["useOfVariables"] === 1 || rowData["useOfVariables"] === "1") {
                            if (rowData.formulaId !== enum__FormulaId.SIMPLE) {
                                if (cellValue === '') {
                                    className = 'jqx-custom-validation-red';
                                }
                                else {
                                    className = '';
                                }
                            }
                        }

                        return className;
                    },
                    editable: profileHasAccess },        
                
                { index: 12,   text: t('data-lang-lbl-bydefault'),               dataField: 'byDefault',             uploadMasive: true,  exportable: true,  width: '100px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'checkbox', 'string'),          columntype: 'checkbox',       cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: profileHasAccess },
                { index: 13,   text: t('data-lang-lbl-objetive'),                dataField: 'objetiveId',            uploadMasive: true,  exportable: true,  width: '100px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listObjetives, 'dropdownlist'),       columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'Objetive_Id',          editorOptions: listObjetives },
                { index: 14,   text: t('data-lang-lbl-goal'),                    dataField: 'goal',                  uploadMasive: true,  exportable: true,  width: '150px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'number'),           columntype: 'numberinput',    cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: profileHasAccess, cellsformat: 'd3', cellsalign: 'right' },
                { index: 15,   text: t('data-lang-lbl-zero_achievement_factor'), dataField: 'zeroAchievementFactor', uploadMasive: true,  exportable: true,  width: '150px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'number'),           columntype: 'numberinput',    
                    cellclassname: (rowIndex, columnField, cellValue, rowData) => {
                        let className = "";
                
                        if (className === "") {
                            const zeroAchievementFactorValue = validateZeroAchievementFactorValue(rowData.objetiveId, rowData.zeroAchievementFactor);

                            if (!zeroAchievementFactorValue) {
                                className = 'jqx-custom-validation-red';
                            }
                        }

                        return className;
                    },
                    editable: profileHasAccess, cellsformat: 'd3', cellsalign: 'right' },
                { index: 16,   text: t('data-lang-lbl-transversal'),             dataField: 'transversal',           uploadMasive: true,  exportable: true,  width: '100px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'checkbox', 'string'),          columntype: 'checkbox',       cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: profileHasAccess },
                { index: 17,   text: t('data-lang-lbl-formula'),                 dataField: 'formulaId',             uploadMasive: true,  exportable: true,  width: '120px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listFormulaId, 'dropdownlist'),       columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'Formula_Id', editorOptions: listFormulaId },  
            ].filter(x => x.dataField !== 'formula');
        }
        else { 
            basicColumns = [
                { index: null, text: 'ID',                                       dataField: 'id',                    uploadMasive: false, exportable: false, width: '0px',   editable: false, hidden: true },
                { index: null, text: t('data-lang-lbl-select'),                  dataField: 'selection',             uploadMasive: false, exportable: false, width: '100px', pinned: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'checkbox', 'string'),          columntype: 'checkbox', editable: true },
                { index: 0,    text: t('data-lang-lbl-code'),                    dataField: 'variableCode',          uploadMasive: true,  exportable: true,  width: '120px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: false, pinned: true },
                { index: 1,    text: t('data-lang-lbl-name'),                    dataField: 'name',                  uploadMasive: true,  exportable: true,  width: '370px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: false, pinned: true },
                { index: 2,    text: t('data-lang-lbl-description'),             dataField: 'description',           uploadMasive: true,  exportable: true,  width: '400px', editable: false },
                { index: 3,    text: t('data-lang-lbl-masterkpi'),               dataField: 'masterKpiId',           uploadMasive: true,  exportable: true,  width: '200px',
                    createwidget: (row, column, value, htmlElement) => { ReactDOM.render(masterKpiCellsRenderer(row, 'masterKpiId', variableList, listMasterKpis), htmlElement); },
                    initwidget:   (row, column, value, htmlElement) => { ReactDOM.render(masterKpiCellsRenderer(row, 'masterKpiId', variableList, listMasterKpis), htmlElement); },
                },
                { index: 4,    text: t('data-lang-lbl-typeof'),                  dataField: 'typeOfId',              uploadMasive: true,  exportable: true,  width: '100px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: false, displayfield: 'TypeOf_Id',            editorOptions: listTypeOfs },
                { index: 5,    text: t('data-lang-lbl-measurementunit'),         dataField: 'measurementUnitId',     uploadMasive: true,  exportable: true,  width: '150px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: false, displayfield: 'MeasurementUnit_Id',   editorOptions: listMeasurmentUnits },  
                { index: 6,    text: t('data-lang-lbl-measurementperiod'),       dataField: 'measurementPeriodId',   uploadMasive: true,  exportable: true,  width: '150px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: false, displayfield: 'MeasurementPeriod_Id', editorOptions: listPeriods },
                { index: 7,    text: t('data-lang-lbl-timeaggregation'),         dataField: 'timeAggregationId',     uploadMasive: true,  exportable: true,  width: '150px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: false, displayfield: 'TimeAggregation_Id',   editorOptions: listAgregations },
                { index: 8,    text: t('data-lang-lbl-useOfVariables'),          dataField: 'useOfVariables',        uploadMasive: true,  exportable: true,  width: '100px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: false },
                { index: 9,    text: t('data-lang-lbl-field-k1'),                dataField: 'k1',                    uploadMasive: true,  exportable: true,  width: '100px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: false, cellsformat: 'n2', cellsalign: 'right' },        
                { index: 10,   text: t('data-lang-lbl-field-k2'),                dataField: 'k2',                    uploadMasive: true,  exportable: true,  width: '100px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: false, cellsformat: 'n2', cellsalign: 'right' },        
                { index: 11,   text: t('data-lang-lbl-field-v1name'),            dataField: 'v1Name',                uploadMasive: true,  exportable: true,  width: '150px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: false },        
                { index: 12,   text: t('data-lang-lbl-field-v2name'),            dataField: 'v2Name',                uploadMasive: true,  exportable: true,  width: '150px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: false },        
                { index: 13,   text: t('data-lang-lbl-bydefault'),               dataField: 'byDefault',             uploadMasive: true,  exportable: true,  width: '100px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: false },
                { index: 14,   text: t('data-lang-lbl-objetive'),                dataField: 'objetiveId',            uploadMasive: true,  exportable: true,  width: '100px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: false, displayfield: 'Objetive_Id',          editorOptions: listObjetives },
                { index: 15,   text: t('data-lang-lbl-goal'),                    dataField: 'goal',                  uploadMasive: true,  exportable: true,  width: '150px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: false, cellsformat: 'n2', cellsalign: 'right' },
                { index: 16,   text: t('data-lang-lbl-zero_achievement_factor'), dataField: 'zeroAchievementFactor', uploadMasive: true,  exportable: true,  width: '150px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: false, cellsformat: 'n2', cellsalign: 'right' },
                { index: 17,   text: t('data-lang-lbl-transversal'),             dataField: 'transversal',           uploadMasive: true,  exportable: true,  width: '100px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: false },
                { index: 18,   text: t('data-lang-lbl-formula'),                 dataField: 'formulaId',             uploadMasive: true,  exportable: true,  width: '120px', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: false, displayfield: 'Formula_Id', editorOptions: listFormulaId },
                
            ].filter(x => x.dataField !== 'formula');
        }

        return basicColumns;
    };

    return (
        <>
            <div className="col-12 listWithActions h-100">
                <div className={inputParam_EditMode ? "card h-100" : "h-100"}>
                    <Card.Header>
                        <Card.Title className="d-flex justify-content-between">
                            <h4><b>{t('data-lang-maintainer-title-variables')}</b></h4>
                        </Card.Title>
                    </Card.Header>
                    <Card.Footer>
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Card.Footer>
                    <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                        <div className="align-items-center h-100">
                            <div className="d-none">
                                <input ref={fileInputRef} type="file" accept=".xlsx" onChange={handlerFileUpload} />
                                <a id="btnGetTemplate" href={TemplateDoc} download="ContractTemplate.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                                <a id="btnGetTemplateJson" href={undefined} download="Template.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                            </div>
                            {
                                variableList && listMasterKpis && listTypeOfs && listMeasurmentUnits && listPeriods && listAgregations && listObjetives &&
                                <>
                                    {
                                        !inputParam_ShowSelection &&
                                        <MatrixToolbar
                                            inputParam_HandleSaveData={handlerSaveAll}
                                            inputParam_HandleUploadData={handlerUploadData}
                                            inputParam_HandleExportData={handlerExportData}
                                            inputParam_HandleAddRow={handlerAddNewRow}
                                            inputParam_Configuration={{
                                                buttons: {
                                                    showRowButtons: profileHasAccess,
                                                    showExportData: true,
                                                    showAddMasiveData: profileHasAccess,
                                                    showAddData: profileHasAccess,
                                                    showDownloadTemplate: profileHasAccess,
                                                    showSaveAllData: profileHasAccess,
                                                    groupedButtons: profileHasAccess
                                                },
                                                handlers: {
                                                    handlerSave: profileHasAccess ? handlerSave : null,
                                                    handlerSaveAll: profileHasAccess ? handlerSaveAll : null,
                                                    handlerDelete: profileHasAccess ? handlerDelete : null,
                                                    handlerCancel: profileHasAccess ? handlerCancel : null,
                                                },
                                                auxiliarListCallbackOnAdd: null,
                                            }}
                                            inputParam_ExternalExportTemplates={[
                                                {
                                                    id: 'btnMantGetTemplate',
                                                    key: 'btnMantGetTemplate',
                                                    text: t('data-lang-lbl-uploadtemplate'),
                                                    iconProps: { iconName: 'ExcelDocument' },
                                                    onClick: () => handlerExportData(false)
                                                },
                                                {
                                                    id: 'btnMantGetTemplateTPOf',
                                                    key: 'btnMantGetTemplateTPOf',
                                                    text: t('data-lang-lbl-typeof'),
                                                    iconProps: { iconName: 'ExcelDocument' },
                                                    onClick: () => onGetTemplateClick('TPOf')
                                                },
                                                {
                                                    id: 'btnMantGetTemplateMUnit',
                                                    key: 'btnMantGetTemplateMUnit',
                                                    text: t('data-lang-lbl-measurementunit'),
                                                    iconProps: { iconName: 'ExcelDocument' },
                                                    onClick: () => onGetTemplateClick('MUnit')
                                                },
                                                {
                                                    id: 'btnMantGetTemplateObj',
                                                    key: 'btnMantGetTemplateObj',
                                                    text: t('data-lang-lbl-objetives'),
                                                    iconProps: { iconName: 'ExcelDocument' },
                                                    onClick: () => onGetTemplateClick('Obj')
                                                },
                                                {
                                                    id: 'btnMantGetTemplateFrm',
                                                    key: 'btnMantGetTemplateFrm',
                                                    text: t('data-lang-lbl-field-formulaid'),
                                                    iconProps: { iconName: 'ExcelDocument' },
                                                    onClick: () => onGetTemplateClick('Frm')
                                                },
                                                {
                                                    id: 'btnMantGetTemplateMaestroKpi',
                                                    key: 'btnMantGetTemplateMaestroKpi',
                                                    text: t('data-lang-lbl-masterkpi'),
                                                    iconProps: { iconName: 'ExcelDocument' },
                                                    onClick: () => onGetTemplateClick('MasterKpi')
                                                },
                                                {
                                                    id: 'btnMantGetTemplatePeriod',
                                                    key: 'btnMantGetTemplatePeriod',
                                                    text: t('data-lang-lbl-measurementperiod'),
                                                    iconProps: { iconName: 'ExcelDocument' },
                                                    onClick: () => onGetTemplateClick('Period')
                                                },
                                                {
                                                    id: 'btnMantGetTemplateAgg',
                                                    key: 'btnMantGetTemplateAgg',
                                                    text: t('data-lang-lbl-timeaggregation'),
                                                    iconProps: { iconName: 'ExcelDocument' },
                                                    onClick: () => onGetTemplateClick('Agg')
                                                }
                                            ]}
                                            inputParam_CustomOpenPanel={false}
                                            showRequiredMessage={showRequiredGlobalMessage}
                                        />
                                    }
                                    {
                                        inputParam_ShowSelection &&
                                        <Checkbox label={t('data-lang-lbl-selectall')} className="py-2" checked={ selectAllVariables } onChange={onChangeSelectAllVariables} />
                                    }
                                    <div id={inputParam_ShowSelection ? "gridConfigElement" : undefined}>
                                        <JqxGrid
                                            ref={gridRef}
                                            altrows={true}
                                            enabletooltips={true}
                                            width={'100%'}
                                            height={"550px"}
                                            theme={'light'} 
                                            editable={true}
                                            sortable={true}
                                            filterable={true}
                                            showfilterrow={true} 
                                            localization={getGridLocalization(t)}
                                            source={ new jqx.dataAdapter({
                                                localData: variableList,
                                                dataType: 'array',
                                                dataFields: [
                                                    { name: 'id',                    type: 'number' },
                                                    { name: 'variableCode',          type: 'string' },
                                                    { name: 'name',                  type: 'string' },
                                                    { name: 'description',           type: 'string' },
                                                    
                                                    { name: 'masterKpiId',           type: 'number' },
                                                    { name: 'MasterKpi_Id',           value: 'masterKpiId', values: { source: listMasterKpis, value: 'id', name: 'name' } },
                                                    
                                                    { name: 'typeOfId',              type: 'number' },
                                                    { name: 'TypeOf_Id',              value: 'typeOfId', values: { source: listTypeOfs, value: 'key', name: 'text' } },
                                                    
                                                    { name: 'measurementUnitId',     type: 'number' },
                                                    { name: 'MeasurementUnit_Id',     value: 'measurementUnitId', values: { source: listMeasurmentUnits, value: 'key', name: 'text' } },
                                                    
                                                    { name: 'measurementPeriodId',   type: 'number' },
                                                    { name: 'MeasurementPeriod_Id',   value: 'measurementPeriodId', values: { source: listPeriods, value: 'key', name: 'text' } },
                                                    
                                                    { name: 'timeAggregationId',     type: 'number' },
                                                    { name: 'TimeAggregation_Id',     value: 'timeAggregationId', values: { source: listAgregations, value: 'key', name: 'text' } },
                                                    
                                                    { name: 'useOfVariables',        type: 'bool' },
                                                    { name: 'k1',                    type: 'float' },
                                                    { name: 'k2',                    type: 'float' },
                                                    { name: 'v1Name',                type: 'string' },
                                                    { name: 'v2Name',                type: 'string' },
                                                    { name: 'byDefault',             type: 'bool' },

                                                    { name: 'objetiveId',            type: 'number' },
                                                    { name: 'Objetive_Id',            value: 'objetiveId', values: { source: listObjetives, value: 'key', name: 'text' } },
                                                    
                                                    { name: 'goal',                  type: 'float' },
                                                    { name: 'zeroAchievementFactor', type: 'float' },
                                                    { name: 'transversal',           type: 'bool' },

                                                    { name: 'formulaId',             type: 'number' },
                                                    { name: 'Formula_Id',             value: 'formulaId', values: { source: listFormulaId, value: 'key', name: 'text' } },

                                                    { name: 'selection',             type: 'bool' },
                                                ],
                                                id: 'id'
                                            })}
                                            columns={getColumns()}
                                            onCellvaluechanged={onCellvaluechanged}
                                            onFilter={(event) => handlerFilter(event, 'Variable')}
                                        />
                                    </div>
                                    
                                </>
                            }
                        </div>
                    </Card.Body>
                </div>           
            </div>
            {
                inputParam_EditMode && listMasterKpis &&
                    <SidePanelSelectMasterKpi
                        isPanelOpen={isPanelSelectMasterKpiOpen}
                        setterIsPanelOpen={setterIsPanelSelectMasterKpiOpen}
                        setterMasterKpiIdOnList={setterMasterKpiOnList}
                        masterKpiSelected={masterKpiSelected}
                        variableId={variableIdSelected}
                        listMasterKpis={listMasterKpis}
                        setListMasterKpis={setListMasterKpis}
                    />
            }
            {
                listObjetives !== null && listMeasurmentUnits !== null &&
                <ModalMasterKpi
                    masterKpiId={masterKpiSelected.masterKpiId}
                    isModalOpen={isModalOpen}
                    hideModal={hideModal}
                    listObjetives={listObjetives}
                    listMeasurmentUnits={listMeasurmentUnits}
                />
            }
        </>
    ); 
}